<template>
  <div data-v-c4709cfa="" data-v-249f9abc="" class="main-header" style="position: sticky;top: 0;z-index: 100;background-color: white;">
    <div data-v-c4709cfa="" class="header">
      <div style="display: flex">
        <div data-v-c4709cfa="" class="wrapper clearfix" >
          <h1 data-v-c4709cfa="" style="display:flex" :title="companyInfo.title">
            <img data-v-c4709cfa="" :src="companyInfo.logo" alt="">
            <div style="margin-left:10px" data-v-c4709cfa="" class="text">
              网上营业厅
            </div>
          </h1>
          <div data-v-c4709cfa="" class="tel right">
            服务热线: <b data-v-c4709cfa="" >{{companyInfo.tel}}</b>
          </div>
        </div>
      </div>
      <div data-v-c4709cfa="" class="nav">
        <div data-v-c4709cfa="" class="wrapper">
          <span data-v-c4709cfa="" v-for="(nav,i) of navs" :key="i" :class="{current:visited===i}" @click="navTo(nav.href,i)">
            {{nav.text}}
          </span>
        </div>
      </div>
    </div>
    <dialog-wechat :show="visiable" @close="visiable=false"></dialog-wechat>
  </div>
  
</template>
<script>
import { mapState, mapMutations, mapGetters } from 'vuex';
import companyInfo from '../config.js'
import dialogWechat from '../components/dialogWechat.vue';
export default {
  props: {
    visited: Number,
  },
  components: {
    dialogWechat
  },
  data(){
    return {
      navs:[
        {
          text: '首页',
          href: '#/home_business',
        },
        {
          text: '客户中心',
          href: '#/kehuzhongxin',
        },
        {
          text: '查交水费',
          href:'#/chajiaoshuifei',
        },
        {
          text: '业务办理',
          href: '#/yewubanli',
        },
        {
          text: '服务指南',
          href: '#/service_guide/0',
        },
        {
          text: '服务动态',
          href: 'home.html#/company_dynamics/0',
        },
        {
          text: '公告信息',
          href: 'home.html#/announcement',
        },
        {
          text: '网上办事',
          href: 'http://zwfw-new.hunan.gov.cn/onething/service/serviceguidecklist.jsp?approve_id=3ffaa2828e4047f5b24581bae463ded0&type=xndtbm',
          // href: 'http://zwfw-new.hunan.gov.cn/onething/service/index.jsp?type=xndtbm&orgId=O8xp2gicWScuqicRJyzfxibDA&main=1&areacode=430401000000',
        },
        
      ],
      visiable:false,
      companyInfo,
      centerDialogVisible:false,
      isUnlogin:true,
      labelPosition: 'right',
      formLabelAlign: {
        name: '',
        region: '',
        type: ''
      }
    }
  },
  computed:{
    ...mapState({
      member: 'member',
      shelf: 'shelf',
    }),
    ...mapGetters({
      size: 'size',
    }),
  },
  methods: {
    centerDialogVisibless(){
      this.centerDialogVisible=false;
      // let res ={
      //   name:'鲍上',
      //   phone:17766269590
      // }
      // this.updateMember(res);
    },
    onLoginClick(){
      this.centerDialogVisible=true
    },
    onUnlogin(){
      this.isUnlogin=false;
      this.updateMember({})
    },
    ...mapMutations({
      updateMember: 'setMember',
      addShelf: 'addShelf',
      updateShelf: 'updateShelf',
    }),
    navTo(href, i) {
      if(href){
          window.location.href = href
          this.$emit('getVisited', i)
      }else{
        this.visiable = true
      }
      
    },
    checkedMenu() {
      this.navs.some((item, i) => {
        if (item.href.split('#')[1] === this.$route.path) {
          // console.log(this.$route.path, hash.split('#')[1])
          this.$emit('getVisited', i)
          return true
        }
      })
    },
  },
  mounted() {
    let that = this
    this.checkedMenu()
    window.addEventListener('hashchange', function () {
      that.checkedMenu()
    })
    // this.checkedMenu()
  },
  watch: {},
}
</script>

<style>
/*.el-button{*/
/*  height: 26px;*/
/*  line-height: 26px;*/
/*}*/
.el-popconfirm__action{
  margin-top: 12px;
}
</style>